import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { Container, CssBaseline } from '@material-ui/core';

const ErrorServiceId = (props) => {
    return (
      <>
      <CssBaseline />
      
        <Header />
        <Container maxWidth="lg">
        <div class="container">
        <div class="bulle">
          <p>Votre ID STIT n'existe pas, Merci de le vérifier</p>
        </div>
        </div>
        </Container>
        <Footer />
        
        
        </>
        
    );
};

export default ErrorServiceId;